import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from '../../core/services/analytics.service';

@Component({
	selector: 'app-promote-your-book-widget',
	templateUrl: './promote-your-book-widget.component.html',
	styleUrls: ['./promote-your-book-widget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class PromoteYourBookWidgetComponent {
	@Input() author;

	get promostacksLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/promo-stacks`;
	}

	get freebooksyLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features/free-booksy`;
	}

	get bargainbooksyLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features/bargain-booksy`;
	}

	get redFeatherRomanceLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features/red-feather-romance`;
	}

	get audioThicketLink(): string {
		return `/author-dashboard/${this.author?.authorLink}/features/audio-thicket`;
	}

	get seeAllPromotions(): string {
		return `/author-dashboard/${this.author?.authorLink}/features`;
	}

	constructor(
		private as: AnalyticsService,
		private router: Router,
	) {}

	goFreebooksy() {
		const options = {
			section: 3,
			section_headline: 'Promote Your Book',
			tile_placement: 1,
			tile_headline: 'Feebooksy',
			brand: 'Freebooksy',
			cta: 'Run a Promo',
			design_variant: 'Image Header',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.freebooksyLink]);
	}

	goBargainBooksy() {
		const options = {
			section: 3,
			section_headline: 'Promote Your Book',
			tile_placement: 2,
			tile_headline: 'Bargain Booksy',
			brand: 'Bargain Booksy',
			cta: 'Run a Promo',
			design_variant: 'Image Header',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.bargainbooksyLink]);
	}

	goRedFeatherRomance() {
		const options = {
			section: 3,
			section_headline: 'Promote Your Book',
			tile_placement: 3,
			tile_headline: 'Red Feather Romance',
			brand: 'Red Feather Romance',
			cta: 'Run a Promo',
			design_variant: 'Image Header',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.redFeatherRomanceLink]);
	}

	goAudioThicket() {
		const options = {
			section: 3,
			section_headline: 'Promote Your Book',
			tile_placement: 4,
			tile_headline: 'Audio Thicket',
			brand: 'Audio Thicket',
			cta: 'Run a Promo',
			design_variant: 'Image Header',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.audioThicketLink]);
	}

	goPromotions() {
		const options = {
			section: 3,
			section_headline: 'Promote Your Book',
			cta: 'See All',
		};
		this.as.homepageTracking(options);

		this.router.navigate([this.seeAllPromotions]);
	}
}
